/** Allowlist of mime types accepted in chat uploads. */
export const ALLOWED_ATTACHMENT_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/heif',
    'image/webp',
    'application/pdf',
];
/** Max bytes per attachment (10 MB). */
export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;
/** Max attachments per chat message. */
export const MAX_ATTACHMENTS_PER_MESSAGE = 3;
